// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"524":"42e668b7","562":"8bfa61a9","963":"d719b153"}[chunkId] + ".chunk.js";
};